import { Query } from '@apollo/client/react/components';
import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';

import {
  WorkbookLineageUpstreamDataQualityWarningsQuery,
  WorkbookLineageUpstreamDataQualityWarningsQueryVariables,
  WorkbookLineageUpstreamDataQualityWarningsDocument
} from '../../../../../gen-src/queries';
import {
  VizPortalDQWDataCatalogProvider,
  WarningStatusChip,
  WarningStatusProps,
} from '../../../data-catalog-shared';
import { ErrorListProvider } from '../error/components/ErrorListProvider';
import { RenderQueryResult } from '../renderQueryResult';
import { emptyWarnings } from './DataQualityWarningCycleTemporaryFix';
import { EmbeddableDataQualityWarningProps } from './EmbeddableDataQualityWarningProps';

interface LineageWarningWorkbookProps {
  readonly vizportalUrlId: string;
}

export type EmbeddableWorkbookDataQualityWarningProps = EmbeddableDataQualityWarningProps & LineageWarningWorkbookProps;

/** @deprecated TFS1478812 */
export function EmbeddableWorkbookDataQualityWarning(props: EmbeddableWorkbookDataQualityWarningProps): JSX.Element {
  const { source, siteUrls: urls } = props;

  const renderData = React.useMemo(() => renderWarnings(urls, source), [urls, source]);

  return (
    <VizPortalDQWDataCatalogProvider {...props}>
      <ErrorListProvider>
        <Query<WarningQuery, WarningVariables>
          query={WorkbookLineageUpstreamDataQualityWarningsDocument}
          variables={{ workbookVizportalUrlId: props.vizportalUrlId, first: 10, offset: 0 }}
        >
          {result => <RenderQueryResult result={result} renderers={{ renderData }} />}
        </Query>
      </ErrorListProvider>
    </VizPortalDQWDataCatalogProvider>
  );

}

type WarningQuery = WorkbookLineageUpstreamDataQualityWarningsQuery;
type WarningVariables = WorkbookLineageUpstreamDataQualityWarningsQueryVariables;

function renderWarnings(urls: SiteUrls, source?: string): (data: WarningQuery) => JSX.Element | null {
  return (data: WarningQuery): JSX.Element | null => {
    const workbook = data.workbooks && data.workbooks[0] ? data.workbooks[0] : null;
    if (!workbook) {
      return null;
    }

    const props: WarningStatusProps = {
      subjectArea: 'Workbook',
      kind: 'graph',
      anchoredAsset: null,
      anchoredWarnings: [],
      iconOnly: false,
      urls,
      upstreamWarnings: workbook.upstreamDataQualityWarningsConnection?.nodes ?? emptyWarnings,
      source: source ?? 'EmbeddableWorkbookDataQualityWarning',
    }

    return <WarningStatusChip {...props} />
  }
}
